import { useQuery } from '@tanstack/react-query';
import { mailCampaignsService } from '../services/mail-campaigns.service';

export function useMailCampaigns(productId: number, params?: Record<string, any>) {
  return useQuery({
    queryKey: ['mail-campaigns', productId, params],
    queryFn: () => mailCampaignsService.list({ productId, ...params }),
    enabled: !!productId,
  });
}

export function useMailCampaign(id: number) {
  return useQuery({
    queryKey: ['mail-campaigns', id],
    queryFn: () => mailCampaignsService.getById(id),
    enabled: !!id,
  });
}

export function useCampaignStatus(id: number, enabled: boolean) {
  return useQuery({
    queryKey: ['mail-campaigns', id, 'status'],
    queryFn: () => mailCampaignsService.getStatus(id),
    enabled: enabled && !!id,
    refetchInterval: 3000,
  });
}
